import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../components/Button.jsx';
import { STANDARD_PACKAGE_PRICE, STANDARD_PACKAGE_TURNAROUND, formatPeso } from '../lib/pricingData.js';
import '../styles/DigitalInvitationFaq.css';

const faqItems = [
  {
    question: 'What is a digital invitation?',
    answer:
      'A digital invitation is an online invitation page you can share through Messenger, Facebook, email, or chat links. It is easier to update than a static image and works well for mobile guests.',
  },
  {
    question: 'How much does a digital invitation cost?',
    answer:
      `The standard E-Invitation package starts at ${formatPeso(STANDARD_PACKAGE_PRICE)} and includes the core invitation website features, RSVP flow, mobile-friendly layout, and shareable link.`,
  },
  {
    question: 'What is included in the standard package?',
    answer:
      'The standard package includes a personalized digital invitation website, animated welcome screen, event details, countdown, background music, RSVP form, guest tracking, maps, seat and attendee tracker, and up to 10 photos.',
  },
  {
    question: 'Can I request a personalized design?',
    answer:
      'Yes. You can choose a sample design direction or request a personalized concept based on your event theme, colors, photos, and special details.',
  },
  {
    question: 'Is RSVP included in the invitation flow?',
    answer:
      'Yes. The service is built around RSVP-ready invitation pages so guests can open the link and respond more easily than with a static file alone.',
  },
  {
    question: 'How long does delivery usually take?',
    answer:
      `Standard delivery is ${STANDARD_PACKAGE_TURNAROUND} once complete and final event details are submitted. Rush handling is available as an add-on when the schedule is tight.`,
  },
];

export default function DigitalInvitationFaq() {
  return (
    <div className="digital-faq-page">
      <section className="digital-faq-hero">
        <p className="digital-faq-eyebrow">Digital invitation FAQ</p>
        <h1>Digital Invitation FAQ for Weddings, Birthdays, and Events</h1>
        <p>
          Read the most common questions about digital invitations, pricing, sample designs,
          personalized design requests, RSVP flow, and how E-Invitation works in the Philippines.
        </p>
      </section>

      <section className="digital-faq-grid">
        {faqItems.map((item) => (
          <article key={item.question} className="digital-faq-card">
            <h2>{item.question}</h2>
            <p>{item.answer}</p>
          </article>
        ))}
      </section>

      <section className="digital-faq-cta">
        <div>
          <h2>Need a sample design or personalized invitation?</h2>
          <p>
            Browse the design gallery first, then book the digital invitation style that fits
            your celebration and timeline.
          </p>
        </div>
        <div className="digital-faq-actions">
          <Link to="/invitations">
            <Button variant="primary" size="large">
              Browse Designs
            </Button>
          </Link>
          <Link to="/book" className="digital-faq-link">
            Start your booking
          </Link>
        </div>
      </section>
    </div>
  );
}
